import apiService from '../../api/apiManager'
import { FileNumberSequenceModel } from '../../../models/systemConfiguration/fileNumberSequence/fileNumberSequenceModel'

class FileNumberSequenceService {
  async apiGetList() {
    return apiService.apiGet(
      '/system-configuration/file-number-sequence/view/list'
    )
  }

  async apiGetById(id: number) {
    return apiService.apiGet(
      `/system-configuration/file-number-sequence/view/${id}`
    )
  }

  async apiAdd(request: FileNumberSequenceModel) {
    return apiService.apiPost(
      '/system-configuration/file-number-sequence/add',
      request
    )
  }

  async apiModify(id: number, request: FileNumberSequenceModel) {
    return apiService.apiPutCommon(
      `/system-configuration/file-number-sequence/modify/${id}`,
      request
    )
  }
}

export default new FileNumberSequenceService()
